export const validateField = (schema: any, value: string) => {
  const result = schema.safeParse(value)
  const errorMessage = result?.error ? result.error.errors[0]?.message : ''

  return {
    errorMessage,
    isValid: result.success
  }
}
